import {
  INVENTORY_ADJUSTMENT_PAGE_REQUEST,
  INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENT_DETAIL,
  INVENTORY_ADJUSTMENT_ADJUSTMENTS_REQUEST,
  INVENTORY_ADJUSTMENT_SET_OUTLETS,
  INVENTORY_ADJUSTMENT_SET_ADJUSTMENTS,
  INVENTORY_ADJUSTMENT_OPEN_RIGHT_COLUMN,
  INVENTORY_ADJUSTMENT_CLOSE_RIGHT_COLUMN,
  INVENTORY_ADJUSTMENT_SUBMIT_FORM_CREATE,
  INVENTORY_ADJUSTMENT_ON_CLICK_ROW,
  INVENTORY_ADJUSTMENT_ON_CLICK_ROW_INGREDIENT_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_SET_ADJUSTMENT_DETAIL,
  INVENTORY_ADJUSTMENT_EXPORT_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_EXPORT_INGREDIENT_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_ON_CLICK_DONE,
  INVENTORY_ADJUSTMENT_ON_CLICK_CREATE_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_SET_CURRENT_PAGE,
  INVENTORY_ADJUSTMENT_SET_TOTAL_PAGE,
  INVENTORY_ADJUSTMENT_ON_CHANGE_OUTLET_IDS,
  INVENTORY_ADJUSTMENT_ON_CHANGE_DATE,
  INVENTORY_ADJUSTMENT_SHOW_ADD_ITEMS_MODAL,
  INVENTORY_ADJUSTMENT_HIDE_ADD_ITEMS_MODAL,
  INVENTORY_ADJUSTMENT_ON_CLICK_ADD_ITEMS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_CANCEL_ADD_ITEMS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_CONFIRM_ADD_ITEMS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_ITEMS_REQUEST,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEMS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_LOADING,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_LOADING,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_SEARCH_ITEMS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_CHANGE_ITEMS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_INGREDIENTS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_SELECTED_ID,
  INVENTORY_ADJUSTMENT_ADJUSTMENT_DETAIL_PAGE,
  INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CHANGE_OUTLET,
  INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CLICK_CANCEL,
  INVENTORY_ADJUSTMENT_SHOW_CONFIRM_SUBMIT_MODAL,
  INVENTORY_ADJUSTMENT_HIDE_CONFIRM_SUBMIT_MODAL,
  INVENTORY_ADJUSTMENT_CONFIRM_SUBMIT,
  INVENTORY_ADJUSTMENT_ON_CHANGE_NAMESPACE,
  INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENTS,
  INVENTORY_ADJUSTMENT_INGREDIENT_ADJUSTMENT_REQUEST,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_INGREDIENTS_REQUEST,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT,
  INVENTORY_ADJUSTMENT_SHOW_IMPORT_MODAL,
  INVENTORY_ADJUSTMENT_HIDE_IMPORT_MODAL,
  INVENTORY_ADJUSTMENT_ON_SUCCESS_IMPORT,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_CURRENT_PAGE,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_TOTAL_PAGE,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_KEYWORD,
  INVENTORY_ADJUSTMENT_SET_SUMMARY_INVENTORY_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_SET_SUMMARY_INGREDIENT_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEM_HAS_RECIPE,
  INVENTORY_ADJUSTMENT_EXPORT_START,
  INVENTORY_ADJUSTMENT_EXPORT_FINISHED,
  INVENTORY_ADJUSTMENT_EXPORT_ERROR,
  INVENTORY_ADJUSTMENT_SET_ASYNCJOBID,
  INVENTORY_ADJUSTMENT_SET_ADDED_ITEM,
} from './constants';

export function pageRequest() {
  return { type: INVENTORY_ADJUSTMENT_PAGE_REQUEST, payload: {} };
}

export function adjustmentsRequest(params, previousAdjustments) {
  return {
    type: INVENTORY_ADJUSTMENT_ADJUSTMENTS_REQUEST,
    payload: { params, previousAdjustments },
  };
}

export function ingredientAdjustmentsRequest(
  params,
  previousIngredientAdjustments
) {
  return {
    type: INVENTORY_ADJUSTMENT_INGREDIENT_ADJUSTMENT_REQUEST,
    payload: { params, previousIngredientAdjustments },
  };
}

export function setOutlets(outlets) {
  return { type: INVENTORY_ADJUSTMENT_SET_OUTLETS, payload: { outlets } };
}

export function setAdjustments(adjustments) {
  return {
    type: INVENTORY_ADJUSTMENT_SET_ADJUSTMENTS,
    payload: { adjustments },
  };
}

export function setIngredientAdjustments(ingredientAdjustments) {
  return {
    type: INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENTS,
    payload: { ingredientAdjustments },
  };
}

export function openRightColumn() {
  return { type: INVENTORY_ADJUSTMENT_OPEN_RIGHT_COLUMN, payload: {} };
}

export function closeRightColumn() {
  return { type: INVENTORY_ADJUSTMENT_CLOSE_RIGHT_COLUMN, payload: {} };
}

export function submitFormCreate(data, previousAdjustments) {
  return {
    type: INVENTORY_ADJUSTMENT_SUBMIT_FORM_CREATE,
    payload: { data, previousAdjustments },
  };
}

export function onClickRow(adjustment) {
  return { type: INVENTORY_ADJUSTMENT_ON_CLICK_ROW, payload: { adjustment } };
}

export function onClickRowIngredientAdjustment(ingredientAdjustment) {
  return {
    type: INVENTORY_ADJUSTMENT_ON_CLICK_ROW_INGREDIENT_ADJUSTMENT,
    payload: { ingredientAdjustment },
  };
}

export function setAdjustmentDetail(adjustment) {
  return {
    type: INVENTORY_ADJUSTMENT_SET_ADJUSTMENT_DETAIL,
    payload: { adjustment },
  };
}

export function setIngredientAdjustmentDetail(ingredientAdjustment) {
  return {
    type: INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENT_DETAIL,
    payload: { ingredientAdjustment },
  };
}

export function exportAdjustment(params, filename, outletId) {
  return {
    type: INVENTORY_ADJUSTMENT_EXPORT_ADJUSTMENT,
    payload: { params, filename, outletId },
  };
}

export function exportIngredientAdjustment(params, filename, outletId) {
  return {
    type: INVENTORY_ADJUSTMENT_EXPORT_INGREDIENT_ADJUSTMENT,
    payload: { params, filename, outletId },
  };
}

export function onClickDone() {
  return { type: INVENTORY_ADJUSTMENT_ON_CLICK_DONE, payload: {} };
}

export function onClickCreateAdjustment(outletId) {
  return {
    type: INVENTORY_ADJUSTMENT_ON_CLICK_CREATE_ADJUSTMENT,
    payload: { outletId },
  };
}

export function adjustmentFormOnChangeOutlet(outletId) {
  return {
    type: INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CHANGE_OUTLET,
    payload: { outletId },
  };
}

export function setCurrentPage(page) {
  return { type: INVENTORY_ADJUSTMENT_SET_CURRENT_PAGE, payload: { page } };
}

export function setTotalPage(page) {
  return { type: INVENTORY_ADJUSTMENT_SET_TOTAL_PAGE, payload: { page } };
}

export function onChangeOutletIds(outletIds, startDate, endDate, namespace) {
  return {
    type: INVENTORY_ADJUSTMENT_ON_CHANGE_OUTLET_IDS,
    payload: { outletIds, startDate, endDate, namespace },
  };
}

/**
 * @param startDate
 * @param endDate
 * @param namespace
 * @param outletIds needed for clevertap (maybe other stuff)
 * @return {{type, payload: {startDate: *, endDate: *, namespace: *, outletIds: *}}}
 */
export function onChangeDate(startDate, endDate, namespace, outletIds) {
  return {
    type: INVENTORY_ADJUSTMENT_ON_CHANGE_DATE,
    payload: { startDate, endDate, namespace, outletIds },
  };
}

export function onChangeNamespace(
  namespace,
  params,
  outletIds,
  startDate,
  endDate
) {
  return {
    type: INVENTORY_ADJUSTMENT_ON_CHANGE_NAMESPACE,
    payload: { namespace, params, outletIds, startDate, endDate },
  };
}

export function showAddItemsModal() {
  return { type: INVENTORY_ADJUSTMENT_SHOW_ADD_ITEMS_MODAL, payload: {} };
}

export function hideAddItemsModal() {
  return { type: INVENTORY_ADJUSTMENT_HIDE_ADD_ITEMS_MODAL, payload: {} };
}

export function onClickAddItems(outletId, namespace) {
  return {
    type: INVENTORY_ADJUSTMENT_ON_CLICK_ADD_ITEMS,
    payload: { outletId, namespace },
  };
}

export function cancelAddItems() {
  return { type: INVENTORY_ADJUSTMENT_ADD_ITEMS_CANCEL_ADD_ITEMS, payload: {} };
}

export function addItemsConfirmAddItems(
  addItemsFormValues,
  adjustments,
  namespace
) {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_CONFIRM_ADD_ITEMS,
    payload: { addItemsFormValues, adjustments, namespace },
  };
}

export function addItemsGetItemsRequest(params, previousItems) {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_ITEMS_REQUEST,
    payload: { params, previousItems },
  };
}

export function addItemsSetKeyword(keyword) {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_KEYWORD,
    payload: { keyword },
  };
}

export function addItemsGetIngredientsRequest(params, previousIngredients) {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_INGREDIENTS_REQUEST,
    payload: { params, previousIngredients },
  };
}

export function addItemsSetItems(items) {
  return { type: INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEMS, payload: { items } };
}

export function setAddedItem(item) {
  return { type: INVENTORY_ADJUSTMENT_SET_ADDED_ITEM, payload: { item } };
}

export function addItemsSetSelectedId(id) {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_SELECTED_ID,
    payload: { id },
  };
}

export function addItemsSetIngredients(ingredients) {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_INGREDIENTS,
    payload: { ingredients },
  };
}

export function addItemsShowLoading() {
  return { type: INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_LOADING, payload: {} };
}

export function addItemsHideLoading() {
  return { type: INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_LOADING, payload: {} };
}

export function addItemsOnSearch(keyword, outletId, namespace) {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_SEARCH_ITEMS,
    payload: { keyword, outletId, namespace },
  };
}

export function addItemsOnChangeSelect(item, namespace, adjustmentForm) {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_CHANGE_ITEMS,
    payload: { item, namespace, adjustmentForm },
  };
}

export function addItemsSetCurrentPage(page) {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_CURRENT_PAGE,
    payload: { page },
  };
}

export function addItemsSetTotalPage(page) {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_TOTAL_PAGE,
    payload: { page },
  };
}

export function setAdjustmentDetailPage(page) {
  return {
    type: INVENTORY_ADJUSTMENT_ADJUSTMENT_DETAIL_PAGE,
    payload: { page },
  };
}

export function adjustmentFormOnClickCancel() {
  return {
    type: INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CLICK_CANCEL,
    payload: {},
  };
}

export function showConfirmSubmitModal() {
  return { type: INVENTORY_ADJUSTMENT_SHOW_CONFIRM_SUBMIT_MODAL, payload: {} };
}

export function hideConfirmSubmitModal() {
  return { type: INVENTORY_ADJUSTMENT_HIDE_CONFIRM_SUBMIT_MODAL, payload: {} };
}

export function confirmSubmit(values, namespace, date, outlet) {
  return {
    type: INVENTORY_ADJUSTMENT_CONFIRM_SUBMIT,
    payload: { values, namespace, date, outlet },
  };
}

export function addItemsShowAlreadyAddedAlert() {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT,
    payload: {},
  };
}

export function addItemsHideAlreadyAddedAlert() {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT,
    payload: {},
  };
}

export function showImportModal() {
  return { type: INVENTORY_ADJUSTMENT_SHOW_IMPORT_MODAL, payload: {} };
}

export function hideImportModal() {
  return { type: INVENTORY_ADJUSTMENT_HIDE_IMPORT_MODAL, payload: {} };
}

export function onSuccessImport() {
  return { type: INVENTORY_ADJUSTMENT_ON_SUCCESS_IMPORT, payload: {} };
}

export function setSummaryAdjustment(summaryAdjustment) {
  return {
    type: INVENTORY_ADJUSTMENT_SET_SUMMARY_INVENTORY_ADJUSTMENT,
    payload: { summaryAdjustment },
  };
}

export function setSummaryIngredientAdjustment(summaryIngredientAdjustment) {
  return {
    type: INVENTORY_ADJUSTMENT_SET_SUMMARY_INGREDIENT_ADJUSTMENT,
    payload: { summaryIngredientAdjustment },
  };
}

export function addItemsSetItemHasRecipe(itemHasRecipe) {
  return {
    type: INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEM_HAS_RECIPE,
    payload: { itemHasRecipe },
  };
}

export function adjustmentExportStart(exportStatus) {
  return { type: INVENTORY_ADJUSTMENT_EXPORT_START, payload: exportStatus };
}

export function adjustmentExportFinished() {
  return { type: INVENTORY_ADJUSTMENT_EXPORT_FINISHED, payload: {} };
}

export function adjustmentExportError(error) {
  return { type: INVENTORY_ADJUSTMENT_EXPORT_ERROR, payload: error };
}

export function setIdAsyncJob(idAsyncJob) {
  return { type: INVENTORY_ADJUSTMENT_SET_ASYNCJOBID, payload: { idAsyncJob } };
}
